import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterModule } from '@angular/router';
import { AuthGuard, CmsConfig, ConfigModule, I18nModule, UrlModule } from '@spartacus/core';
import { IconModule, MediaModule } from '@spartacus/storefront';
import { MatButtonModule } from '@angular/material/button';
import { MatDialogModule } from '@angular/material/dialog';
import { MatIconModule } from '@angular/material/icon';
import { KbMyProfileComponent } from './kb-my-profile.component';
import { KbCloseMyAccpopupComponent } from './kb-close-my-accpopup/kb-close-my-accpopup.component';
import { ConfirmCloseAccPopupComponent } from './confirm-close-acc-popup/confirm-close-acc-popup.component';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { KbMyAccountLeftSideNavModule } from '../my-account-left-sidenav/my-account-left-sidenav.module';
import { SecureGuard } from 'src/app/services/Guards/secure.service';



@NgModule({
    declarations: [KbMyProfileComponent, KbCloseMyAccpopupComponent, ConfirmCloseAccPopupComponent],
    imports: [
        CommonModule,
        RouterModule,
        UrlModule,
        IconModule,
        I18nModule,
        MatDialogModule,
        MatButtonModule,
        MatIconModule,
        MediaModule,
        FormsModule,
        ReactiveFormsModule,
        KbMyAccountLeftSideNavModule,
        ConfigModule.withConfig({
            cmsComponents: {
                UpdateProfileComponent: {
                    component: KbMyProfileComponent,
                    guards: [SecureGuard, AuthGuard]
                },
                CloseAccountComponent: {
                    component: KbCloseMyAccpopupComponent,
                    guards: [SecureGuard, AuthGuard]
                }
            }
        } as CmsConfig)
    ],
})
export class KbMyProfileModule { }
